import { makeStyles } from "tss-react/mui";

import { OtaFile } from "@dashboard/rollouts/types";
import { Tag } from "@dashboard/shared/components/Tag/Tag";
import { Box, Theme } from "@mui/material";

const useStyles = makeStyles()((theme: Theme) => ({
    row: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
}));

type Props = {
    otaFile: OtaFile;
};

export const VersionMeta = ({ otaFile }: Props) => {
    const { classes } = useStyles();

    const userTags = Object.entries(otaFile.annotation?.metadata?.user ?? {}).map(([key, value]): API.Tag => ({
        key,
        value,
        type: value ? "scoped" : "simple",
    }));

    const versionTag: API.Tag = { key: "version", value: otaFile.version, type: "scoped" };
    const channelTag: API.Tag = { key: "channel", value: otaFile.channel ?? "none", type: "scoped" };

    return (
        <Box className={classes.row}>
            <Tag item={versionTag} theme="light" />
            <Tag item={channelTag} theme="light" />
            {userTags.map((tag) => (
                <Tag key={tag.key} item={tag} />
            ))}
        </Box>
    );
};
